import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { fetchAllSections } from '@store/thunk/section.thunk'
import { SectionState } from '@store/slices/section.slice'

export const sectionExtraReducers = (
  builder: ActionReducerMapBuilder<SectionState>
) => {
  builder
    .addCase(fetchAllSections.pending, (state) => {
      state.sectionList = []
      state.loading = true
      state.error = null
    })
    .addCase(fetchAllSections.fulfilled, (state, action) => {
      state.sectionList = action.payload.sections
      state.loading = false
    })
    .addCase(fetchAllSections.rejected, (state) => {
      state.loading = false
      state.error = 'Přihlášení selhalo'
    })
}
